{
  "remove": "削除"
}
